import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { PolicyApiPort } from './ports/policy-api.port';
import { AdessoPolicyApiAdapter } from './adapters/adesso-policy-api.adapter';

/**
 * Provides PolicyApiPort backed by the adesso-connector-api adapter.
 */
export function providePolicyApi(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: PolicyApiPort, useClass: AdessoPolicyApiAdapter }
  ]);
}
